import React from 'react';
import { graphql } from 'gatsby';

import PropTypes from 'prop-types';
import Layout from '../components/layout';
import Faq from '../templates/faq';
import SEO from '../components/seo';
import Header from '../components/header';

const AboutPage = ({
  data: {
    allContentfulFaqCategory: { edges: faq },
    allContentfulContacts: { edges: rawContacts },
  },
  location,
}) => {
  const contacts = {};
  // eslint-disable-next-line no-return-assign
  rawContacts.forEach(({ node: { type, value } }) => (contacts[type] = value));
  return (
    <Layout>
      <SEO
        lang="ru"
        title="О Нас"
        keywords={[
          'faq',
          'чаво',
          'часто задаваемые вопросы',
          'вопросы',
          'задать вопрос',
          'контакты',
          'отель',
          'гостевой',
          'дом',
          'hotel',
          'guest',
          'house',
          'dom',
          'yalta',
          'гостевой дом',
          'guest house',
          'dom_yalta',
          'аренда',
          'аренда жилья',
          'аренда жилья в ялте 2019',
          'отдых в ялте 2019',
          'семейный отдых',
        ]}
        jsonld={Faq.JSONLD({ items: faq })}
      />
      <Header contacts={contacts} location={location} sticky />
      <main className="main">
        <div className="pagecontent">
          <div className="container">
            <Faq items={faq} contacts={contacts} />
          </div>
        </div>
      </main>
    </Layout>
  );
};

export const query = graphql`
  query {
    allContentfulContacts {
      edges {
        node {
          id
          type
          value
        }
      }
    }
    allContentfulFaqCategory(sort: { fields: [order], order: ASC }) {
      edges {
        node {
          id
          title
          questions {
            id
            question
            answer_rich {
              json
            }
          }
        }
      }
    }
  }
`;

AboutPage.propTypes = {
  data: PropTypes.shape({
    allContentfulFaqCategory: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
    allContentfulContacts: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
  }).isRequired,
};

export default AboutPage;
